export const getRatesParam = (data: any) => {
  return data.ratesAndFeesLinkParameters.reduce(
    (acc: Record<string, unknown>, i: { name: string; parameter: string }) => {
      const arr = i.parameter.split('=')
      return { ...acc, [arr[0]]: arr[1] }
    },
    {},
  )
}
